export default {
  nav: {
    home: 'Home',
    services: 'Services',
    solutions: 'Solutions',
    cases: 'Cases',
    partners: 'Partners',
    news: 'News',
    contact: 'Contact',
    smb: 'SMB',
    logo: 'DianYi Cloud'
  },
  hero: {
    title: 'Global Leading Cloud Service Provider',
    company: 'DianYi Cloud',
    subtitle: 'Through technological innovation and resource integration, we provide comprehensive cloud service solutions for enterprises, helping customers achieve global business expansion in the AI era.',
    learnMore: 'Learn More',
    contactUs: 'Contact Us',
    stats: {
      countries: 'Countries',
      availability: 'Service Availability'
    },
    partners: {
      alt: 'Partners'
    }
  },
  services: {
    title: 'Services',
    subtitle: 'Comprehensive Cloud Service Solutions for Enterprises',
    items: {
      cloud: {
        title: 'Public Cloud Agency',
        desc: 'Providing stable, efficient, and secure cloud computing services with quick account setup and 24/7 technical support'
      },
      gpu: {
        title: 'GPU Computing Service',
        desc: 'High-performance GPU cloud hosts specifically designed for AI training and deep learning scenarios'
      },
      ai: {
        title: 'AI Overseas Matrix Marketing',
        desc: 'One-stop solution: Cloud Phone + Automation Robot + AIGC'
      },
      edge: {
        title: 'Edge Computing',
        desc: '200+ global edge nodes providing efficient cross-border network services'
      },
      security: {
        title: 'AI Applications',
        desc: 'Efficiently processing massive data and complex models, providing powerful computing capabilities and resources for AI applications'
      },
      sms: {
        title: 'International SMS Marketing',
        desc: 'Covering 230 countries and regions worldwide, supporting multiple languages, helping enterprises expand overseas markets simply, quickly, and cost-effectively'
      }
    }
  },
  solutions: {
    title: 'Solutions',
    subtitle: 'Comprehensive Technical Support for Your Business',
    items: {
      crossBorder: {
        title: 'One-Stop Overseas Solution',
        desc: 'Providing enterprises with a complete cross-border business platform, including market research, strategy planning, and operation management'
      },
      sms: {
        title: 'International SMS Service',
        desc: 'Providing globally covered SMS sending services with multi-language support, high delivery rate, and fast stability'
      },
      ddos: {
        title: 'Anti-DDoS Solution',
        desc: 'Providing powerful DDoS protection capabilities to protect your business from various network attacks'
      },
      acceleration: {
        title: 'Cross-Border Acceleration Security Solution',
        desc: 'Providing secure, stable, and high-speed network acceleration services for your cross-border business through global node network'
      }
    }
  },
  cases: {
    title: 'Case Studies',
    subtitle: 'Explore our success stories and learn how we create value for our clients',
    viewDetails: 'View Details',
    cards: {
      fengrui: {
        title: 'Guangxi Fengrui Information Technology Cloud Migration Success',
        desc: 'Helped the enterprise migrate to AWS Cloud, improving performance and reducing O&M costs'
      },
      bairui: {
        title: 'Wuhan Bairui Technology Cloud Hosting Success',
        desc: 'Provided high-performance cloud hosting for a gaming company, supporting players worldwide'
      },
      inventoryGame: {
        title: 'Inventory Management System Migration Success',
        desc: 'Delivered reliable cloud services for the inventory system to enhance user experience'
      },
      inventoryStable: {
        title: 'Data Management System Cloud Enablement',
        desc: 'Provided strong compute and storage resources to improve data processing capacity'
      }
    },
    items: {
      crossBorder: {
        title: 'Cross-Border E-commerce Solution',
        desc: 'Provided a one-stop overseas solution for a well-known cross-border e-commerce platform, including payment systems, logistics integration, and multi-language support, helping the client quickly expand into overseas markets.',
        tags: {
          ecommerce: 'Cross-Border E-commerce',
          payment: 'Payment System',
          multilingual: 'Multi-language'
        }
      },
      ddos: {
        title: 'Anti-DDoS Protection Solution',
        desc: 'Provided an anti-DDoS solution for a gaming company, effectively defending against various network attacks through an intelligent protection system, ensuring stable operation of game servers.',
        tags: {
          protection: 'DDoS Protection',
          gameserver: 'Game Server',
          security: 'Network Security'
        }
      }
    },
    backToHome: 'Back to Home'
  },
  news: {
    title: 'Company News',
    subtitle: 'Learn about our latest developments',
    content: {
      paragraph1: 'Hong Kong DianYi Cloud Technology Co., Ltd. is a core-level service partner of Huawei Cloud, Tencent Cloud, Alibaba Cloud, Amazon Cloud, and other cloud manufacturers. We are dedicated to providing cloud operation and maintenance hosting, cost management, architecture consulting, cloud migration, database, and other services, covering industries such as gaming, video streaming, WEB3, retail e-commerce, AI intelligence, and new energy. We consistently provide reliable cloud services and solutions to our clients. Through deep technical integration with major cloud manufacturers, we provide solutions for video streaming, WEB3 blockchain ecosystem, modern AI intelligent analysis, game hosting and operation, e-commerce services, content moderation, and other industries. We will continue to explore cloud computing innovation and reform, providing more comprehensive, efficient, and secure cloud services to help our clients succeed in the digital era.',
      paragraph2: 'DianYi Cloud is headquartered in Hong Kong with branches in Dubai and Shenzhen. Our current team has over 50 members, and the company holds professional certifications from AWS, Tencent Cloud, and Huawei Cloud. All team members have over three years of experience in the IT internet industry, possessing rich technical expertise and experience.'
    }
  },
  partners: {
    title: 'Partners',
    items: {
      partner1: 'Huawei Cloud',
      partner2: 'Tencent Cloud',
      partner3: 'Alibaba Cloud',
      partner4: 'Amazon Cloud',
      partner5: 'Microsoft Cloud',
      partner6: 'Google Cloud'
    }
  },
  contact: {
    title: 'Contact Us',
    subtitle: 'Professional Service Available 24/7',
    email: {
      title: 'Email',
      value: 'san@dycloud.ai'
    },
    phone: {
      title: 'Phone',
      value: '15989283653 Mr. Liu'
    },
    wechat: {
      title: 'WeChat',
      qrcode: 'WeChat QR Code',
      scan: 'Scan to add WeChat'
    },
    copyright: '© 2024 Hong Kong DianYi Cloud Technology Co., Ltd. All rights reserved.'
  }
} 